var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetPasswordIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Key_lock_icon",
    "data-name": "Key/lock icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 158.332,
    height: 230.029,
    viewBox: "0 0 158.332 230.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M1055.739,309.056H921.183a11.9,11.9,0,0,1-11.888-11.888V177.908a11.9,11.9,0,0,1,11.888-11.887h134.556a11.9,11.9,0,0,1,11.888,11.887v119.26A11.9,11.9,0,0,1,1055.739,309.056Zm-128.444-18h122.332V184.021H927.295Z",
    transform: "translate(-909.295 -79.027)",
    fill: "#13347D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M1030.684,180.7a9,9,0,0,1-9-9V131.273a34.247,34.247,0,0,0-68.493,0,9,9,0,0,1-18,0,52.246,52.246,0,0,1,104.493,0V171.7A9,9,0,0,1,1030.684,180.7Z",
    transform: "translate(-909.295 -79.027)",
    fill: "#13347D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M1002.705,281.345H974.55a7,7,0,0,1-6.935-7.957L972.32,239.3a24.994,24.994,0,0,1-11.809-20.909c0-14.145,12.613-25.653,28.117-25.653s28.116,11.508,28.116,25.653a25.136,25.136,0,0,1-11.81,20.908l4.706,34.093a7,7,0,0,1-6.935,7.957Zm-20.123-14h12.091l-3.983-28.851v-.012l-.316-2.321a7,7,0,0,1,4.471-7.5l1.673-.629c3.907-2.191,6.227-5.773,6.227-9.648,0-6.426-6.332-11.653-14.116-11.653s-14.117,5.227-14.117,11.653a11.176,11.176,0,0,0,5.613,9.282l2.9,1.471a7,7,0,0,1,3.794,6.961l-.222,2.155c-.008.08-.018.159-.029.238Z",
    transform: "translate(-909.295 -79.027)",
    fill: "#13347D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPasswordIcon);
export default __webpack_public_path__ + "static/media/resetPasswordIcon.4620e2affbeb1f4139f4556f1841c7f1.svg";
export { ForwardRef as ReactComponent };